module.exports = __webpack_public_path__ + "img/none_data_cn.b33f69e4.png";